import React from 'react';
import { Grid } from '@mui/material';
import { Colors, PrimaryButton, SecondaryButton, Text } from 'library';
import { ITeacher } from 'models';
import { Selections } from './EditOrCreateNewJobModal';

export default function EditOrCreateNewJob({
    selectedWorkers,
    goToNext,
}: {
    selectedWorkers: ITeacher[];
    goToNext: (selection: Selections) => void;
}) {
    const [selection, setSelection] = React.useState<Selections>();

    function ButtonContent({ title, subtitle }: { title: string; subtitle: string }) {
        return (
            <Grid container flexDirection="column" gap={1} padding={2} alignItems="flex-start">
                <Text variant="h2" bold color={Colors.turquoise} textStyle={{ fontSize: 20 }}>
                    {title}
                </Text>
                <Text variant="body2">{subtitle}</Text>
            </Grid>
        );
    }

    return (
        <>
            <Text variant="h1" textStyle={{ fontSize: 28 }}>
                Invite Teachers
            </Text>
            <Text variant="body1" bold textStyle={{ marginBottom: 20, marginTop: 20 }}>
                Selected teachers:{' '}
                <Text variant="body1" inline>
                    {selectedWorkers.map((w) => w.name).join(', ')}
                </Text>
            </Text>
            <Grid container flexDirection="column" gap={2} flex={1}>
                <Grid container gap={2} flexDirection="column" flex={1}>
                    <SecondaryButton
                        disableRipple
                        onClick={() => setSelection(Selections.Create)}
                        buttonStyle={{
                            ...styles.button,
                            ...(selection === Selections.Create ? styles.selectedButton : {}),
                        }}
                    >
                        <ButtonContent
                            title="Create a new job and invite"
                            subtitle="Add job details and invite selected teachers."
                        />
                    </SecondaryButton>
                    <SecondaryButton
                        disableRipple
                        onClick={() => setSelection(Selections.Invite)}
                        buttonStyle={{
                            ...styles.button,
                            ...(selection === Selections.Invite ? styles.selectedButton : {}),
                        }}
                    >
                        <ButtonContent
                            title="Invite to existing job"
                            subtitle="Choose an existing job and invite selected teachers."
                        />
                    </SecondaryButton>
                </Grid>
                <Grid container flexDirection="column" justifyContent="flex-end" flex={1}>
                    <PrimaryButton
                        disabled={!selection}
                        onClick={() => goToNext(selection || Selections.Create)}
                        rightAlign
                    >
                        Next
                    </PrimaryButton>
                </Grid>
            </Grid>
        </>
    );
}

const styles = {
    button: {
        borderRadius: 18,
        padding: 10,
        justifyContent: 'flex-start',
        minHeight: 99,
    },
    selectedButton: {
        backgroundColor: Colors.lightTurq,
        border: `1px solid ${Colors.turquoise}`,
    },
};
